<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'rotas') {
            next({ name: 'rota-list', replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'rotas') {
            this.$router.replace({ name: 'rota-list' });
        }
    },
};
</script>
